import { Box, Breadcrumbs, Button, ButtonProps, Card, CardContent, Checkbox, Divider, FormControlLabel, FormGroup, Grid, IconButton, Link, Stack, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import authStore from "../../stores/AuthStore";
import DeleteIcon from '@mui/icons-material/Delete';
import SimpleBackdrop from "../../components/SimpleBackdrop";
import DialogConfirm from "../../components/DialogConfirm";
import productCategoriesStore from "../../stores/ProductCategoriesStore";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ProductCategoryCreate: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [productGroup, setProductGroup] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState({
        open: false,
        title: '',
        message: '',
        color: 'primary' as ButtonProps['color'],
        type: 'create' as 'create' | 'edit' | 'delete'
    });
    const permission: any = authStore.user?.roles.find((role: any) => role.menu.path === '/product-categories');
    const [isCommonFee, setIsCommonFee] = useState(false);

    useEffect(() => {
        if (id) {
            setIsLoading(true);
            productCategoriesStore.get(id).then((res) => {
                if (res.error) {
                    enqueueSnackbar('ไม่พบข้อมูล', { variant: 'error' });
                    setIsLoading(false);
                    return;
                }
                setProductGroup(res.name);
                setIsCommonFee(res.isCommonFee);
                setIsLoading(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSave = () => {
        if (!id) {
            setIsLoading(true);
            productCategoriesStore.create({
                name: productGroup,
                isCommonFee: isCommonFee,
                createBy: authStore.user?.id,
                createAt: new Date(),
            }).then((res) => {
                setIsLoading(false);
                if (res.error) {
                    enqueueSnackbar('บันทึกข้อมูลไม่สำเร็จ', { variant: 'error' });
                    return;
                }
                enqueueSnackbar('บันทึกข้อมูลสำเร็จ', { variant: 'success' });
                navigate(`/product-category-edit/${res.id}`);
            });
        }
    };

    const handleEdit = () => {
        if (id) {
            setIsLoading(true);
            productCategoriesStore.update(id, {
                name: productGroup,
                isCommonFee: isCommonFee,
                updateBy: authStore.user?.id,
                updateAt: new Date(),
            }).then((res) => {
                setIsLoading(false);
                if (res.error) {
                    enqueueSnackbar('บันทึกข้อมูลไม่สำเร็จ', { variant: 'error' });
                    return;
                }
                enqueueSnackbar('บันทึกข้อมูลสำเร็จ', { variant: 'success' });
            });
        }
    };

    const handleDelete = () => {
        if (id) {
            setIsLoading(true);
            productCategoriesStore.update(id, {
                isActive: false,
                updateBy: authStore.user?.id,
                updateAt: new Date(),
            }).then((res) => {
                setIsLoading(false);
                if (res.error) {
                    enqueueSnackbar('ลบประเภทสินค้าไม่สำเร็จ', { variant: 'error' });
                    return;
                }
                enqueueSnackbar('ลบประเภทสินค้าสำเร็จ', { variant: 'success' });
                navigate('/product-categories');
            });
        }
    };

    const handleIsCommonFee = () => {
        setIsCommonFee(!isCommonFee);
    };

    return (
        <Box component={'div'}>
            <Grid container>
                <Grid item xs={0.5}>
                    <IconButton aria-label="delete" onClick={() => navigate('/product-categories')}>
                        <ArrowBackIcon />
                    </IconButton>
                </Grid>
                <Grid item xs={8.5} display={'flex'} alignItems={'center'}>
                    <Breadcrumbs separator="›" aria-label="breadcrumb">
                        <Typography>การจัดการ</Typography>
                        <Link component="button" onClick={() => navigate('/product-categories')}>ประเภทสินค้า</Link>
                        <Typography variant="h6" color="text.primary">{id ? 'แก้ไข' : 'สร้าง'}</Typography>
                    </Breadcrumbs>
                </Grid>
                <Grid item xs={3} display={'flex'} justifyContent={'end'}>
                    {((permission && permission.delete) || authStore.user?.isSuperAdmin) && id &&
                        <Button variant="contained" color="error" startIcon={<DeleteIcon />} onClick={() => setOpenConfirm({
                            open: true,
                            title: 'ลบข้อมูล',
                            message: 'คุณต้องการลบประเภทสินค้านี้ใช่หรือไม่',
                            color: 'error',
                            type: 'delete'
                        })}>ลบข้อมูล</Button>
                    }
                </Grid>
            </Grid>
            <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                    <TextField id="outlined-basic" label="ชื่อประเภทสินค้า" variant="outlined" fullWidth
                                        onChange={(event) => setProductGroup(event.target.value)} value={productGroup}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel control={<Checkbox onChange={handleIsCommonFee} checked={isCommonFee} />} label="ส่วนกลาง" />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12}><Divider /></Grid>
                                <Grid item xs={12} >
                                    <Grid container justifyContent="flex-end">
                                        <Grid item xs={4} >
                                            <Stack spacing={2} direction="row">
                                                <Button variant="outlined" fullWidth onClick={() => navigate('/product-categories')}>ยกเลิก</Button>
                                                {!id && <Button variant="contained" fullWidth onClick={() => {
                                                    setOpenConfirm({
                                                        open: true,
                                                        title: 'บันทึกเอกสาร',
                                                        message: 'คุณต้องการบันทึกเอกสารนี้ใช่หรือไม่',
                                                        color: 'primary',
                                                        type: 'create'
                                                    });
                                                }}>บันทึก</Button>}
                                                {((permission && permission.edit) || authStore.user?.isSuperAdmin) && id && <Button variant="contained" fullWidth onClick={() => {
                                                    setOpenConfirm({
                                                        open: true,
                                                        title: 'แก้ไขเอกสาร',
                                                        message: 'คุณต้องการแก้ไขเอกสารนี้ใช่หรือไม่',
                                                        color: 'primary',
                                                        type: 'edit'
                                                    });
                                                }}>แก้ไข</Button>}
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <SimpleBackdrop open={isLoading} />
            <DialogConfirm open={openConfirm.open} type={openConfirm.color} title={openConfirm.title} message={openConfirm.message} onClose={() => setOpenConfirm({ ...openConfirm, open: false })}
                onSubmit={() => {
                    setOpenConfirm({ ...openConfirm, open: false });
                    if (openConfirm.type === 'delete') {
                        handleDelete();
                    } else if (openConfirm.type === 'create') {
                        handleSave();
                    } else if (openConfirm.type === 'edit') {
                        handleEdit();
                    }
                }} />
        </Box>
    );
};

export default ProductCategoryCreate;
